module.exports = __webpack_public_path__ + "img/wyglfw2.e8cfd39f.png";